import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { registrarServiceWorker } from "./registrarServiceWorker";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Va al final y se engancha a `load`: no debe competir con el primer pintado.
registrarServiceWorker();
